<template lang="pug">
.content
    .res(:class="`r${res.x}x${res.y}`")
        Vid.vid(ref="vids" :src="vidsrc" :loop="datas[cur].loop" :endCallBack="onPlayEnd" :width="res.x" :height="res.y" :muted="cur===0") 
        .g1.abs.l.t(v-show="cur===0")
            .abs.cont.bt0.b1.hand(:style="`backgroundImage:url(${path}${lang}imgs/1.png)`" @click="()=>handleHot('hot1')" ref="r1" v-show="hy!==0")
            .abs.cont.bt0.b2.hand(:style="`backgroundImage:url(${path}${lang}imgs/2.png)`" @click="()=>handleHot('hot2')" ref="r2" v-show="hy!==1")
            .abs.cont.bt0.b3.hand(:style="`backgroundImage:url(${path}${lang}imgs/3.png)`" @click="()=>handleHot('hot3')" ref="r3" v-show="hy!==2")
            .abs.cont.bt0.b4.hand(:style="`backgroundImage:url(${path}${lang}imgs/4.png)`" @click="()=>handleHot('hot4')" ref="r4" v-show="hy!==3")
            //- .abs.cont.bt.bt2.hand(:style="`backgroundImage:url(${path}${lang}imgs/1a.png)`" ref="h1" @click="()=>handleHot('hot1')" @mouseover="()=>onover(1)" @mouseleave="()=>onleave(1)")
            //- .abs.cont.bt.bt3.hand(:style="`backgroundImage:url(${path}${lang}imgs/2a.png)`" ref="h2" @click="()=>handleHot('hot2')" @mouseover="()=>onover(2)" @mouseleave="()=>onleave(2)")
            //- .abs.cont.bt.bt4.hand(:style="`backgroundImage:url(${path}${lang}imgs/3a.png)`" ref="h3" @click="()=>handleHot('hot3')" @mouseover="()=>onover(3)" @mouseleave="()=>onleave(3)")
            //- .abs.cont.bt.bt5.hand(:style="`backgroundImage:url(${path}${lang}imgs/4a.png)`" ref="h4" @click="()=>handleHot('hot4')" @mouseover="()=>onover(4)" @mouseleave="()=>onleave(4)")
            .abs.cont.bt.bt2.hand.flexCenter(:style="`backgroundImage:url(${path}${lang}imgs/1a.png)`" @click="()=>handleHot('hot1')" ref="h1" v-show="hy===0")
                .c1.cont.abs.pulseForever1(:style="`backgroundImage:url(${path}imgs/3.png)`")
            .abs.cont.bt.bt3.hand(:style="`backgroundImage:url(${path}${lang}imgs/2a.png)`" @click="()=>handleHot('hot2')" ref="h2" v-show="hy===1")
                .c1.cont.abs.pulseForever1(:style="`backgroundImage:url(${path}imgs/3.png)`")
            .abs.cont.bt.bt4.hand(:style="`backgroundImage:url(${path}${lang}imgs/3a.png)`" @click="()=>handleHot('hot3')" ref="h3" v-show="hy===2")
                .c1.cont.abs.pulseForever1(:style="`backgroundImage:url(${path}imgs/3.png)`")
            .abs.cont.bt.bt5.hand(:style="`backgroundImage:url(${path}${lang}imgs/4a.png)`" @click="()=>handleHot('hot4')" ref="h4" v-show="hy===3")
                .c1.cont.abs.pulseForever1(:style="`backgroundImage:url(${path}imgs/3.png)`")
            //- .ihand.abs.cont(:style="`backgroundImage:url('./static/icon/hand.gif');left:${pxToRem(1686+50)};top:${pxToRem(hy)}`")
            .cover.abs.hand(@click="()=>handleHot('hot1')")
        //- .g2.abs.l.t(v-show="'P0_P2_P1_P3_N3_N1_N2_s2_N4-1_N4-2'.split('_').indexOf(curname)!==-1")
        //-     .ico.abs.hand.cont.c3size.c3l-1.c3t(style="backgroundImage:url('./static/icon/deepen.png')" v-show="lang==='cn/'" @click="setLang('en')")
        //-     .ico.abs.hand.cont.c3size.c3l-1.c3t(style="backgroundImage:url('./static/icon/deepcn.png')" v-show="lang==='en/'" @click="setLang('cn')")
        .g3.abs.l.t(v-show="curname==='N4-1'")
            .ico.abs.hand.cont.b1(@click="()=>setNam('fabric')")
            .ico.abs.hand.cont.b2(@click="()=>setNam('dme')")
            .ico.abs.hand.cont.b3(@click="()=>setNam('P3')")
            .ico.abs.hand.cont.b4(@click="()=>setNam('N3')")

        ul.ui.abs.l.t
            li.abs.cont.hand(
                v-for="item,id in ui" 
                :key="id" 
                :style="`backgroundImage:url(${item.src});width:${pxToRem(item.w)};height:${pxToRem(item.h)};left:${pxToRem(item.l)};top:${pxToRem(item.t)}`"
                v-show="item.vis.split('_').indexOf(curname)!==-1||item.vis===''"
                @click="()=>handleUI(item.cmd,item.arg)"
                )

        ul.hot.ui.abs.l.t
            li.abs.hand(
                v-for="item,id in hots" 
                :key="id" 
                :style="`backgroundColor:red;opacity:${hotAlpha};width:${pxToRem(item.w)};height:${pxToRem(item.h)};left:${pxToRem(item.l)};top:${pxToRem(item.t)};`"
                v-show="item.vis.split('_').indexOf(curname)!==-1||item.vis===''"
                @click="()=>handleHot(item.cmd,item.arg)"
                )
        //- Pop.pop(
        //-     ref='pop'
        //-     w=960
        //-     h=540
        //-     :src="`${path}${lang}${popnam}.mp4`"
        //- )
        //-     .back(@click='onback()')
        //- .vidwrapper.abs.l.t(v-if="curname==='2'&&showPop" :class="isFull?'big':'small'")
        //-     Video.popvid.abs(:src="`${path}${lang}s2.mp4`" autoplay loop ref="svid")
        //-     .cover.abs.l.r.hand(@click="oncover")
        Info(:w="res.x" :h="res.y" v-if="debug")
        //- img.img1(:src="`${path}${lang}s1.svg`")
        //- object(id="object" :data="`${path}${lang}s1.svg`" type="image/svg+xml" style="position:absolute;top:0px;")
        //- iframe(id="iframe" :src="`${path}${lang}s1.svg`")
        .gtime(v-show="curname==='A1'")
            span {{ctime}}/{{ttime}}
        
        .Debug(v-if="debug") {{cur}} {{lang}} {{vidsrc}} {{curname}}

</template>
<script>
//import axios from 'axios'
import FontService from '@/services/FontService'
import KeyService from '@/services/KeyService'
import SocketService from '@/services/SocketService'
import { mapMutations, mapState } from 'vuex'
import ResizeService from '@/services/ResizeService'
import Vid from '@/components/common/VidSimple4'
import HotPP from '@/components/common/HotPP'
import Breath from '@/components/common/Breath'
import Pop from '@/components/common/Pop'
import ProgressBar from '@/components/common/ProgressBar2'
import Info from '@/components/common/Info'
import basefunc from '@/components/common/basefunc'
import Hot from '@/components/common/Hot2'
import gsap from 'gsap'
const configdata={
    "debug":false,
    "path":"./static/A/A3/",
    "isc3":false,
    "isofficial":false,
    "startLan":"en",
    "res":{"x":1920,"y":1080},
    "datas":[
        {"name":"P0","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"P2","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"P1","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"fabric","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"dme","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"P3","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"N3","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"N1","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"s2","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"N4-1","type":"mp4","loop":false,"next":"","key":"a"},
        {"name":"N4-2","type":"mp4","loop":false,"next":"","key":"a"},
        {"name":"N2","type":"mp4","loop":true,"next":"","key":"a"}

    ],
    "hotAlpha":0,
    "hots":[

        {"cmd":"hot","arg":"17","vis":"21","l":2212,"t":1828,"w":608,"h":114}

    ],
    "ui":[
        {"src":"./static/icon/deepprev.png","cmd":"prev","arg":"","vis":"P1_dme_N1_N2_N3_N2","l":1668,"t":1002,"w":48,"h":48},
        {"src":"./static/icon/deepnext.png","cmd":"next","arg":"","vis":"P2_fabric_P3_N1_N4-2","l":1726,"t":1002,"w":48,"h":48},
        {"src":"./static/icon/deephome.png","cmd":"back","arg":"P0","vis":"P2_P1_fabric_dme_P3_N3_N1_N2_s2_N4-1_N4-2","l":1784,"t":1002,"w":48,"h":48},
        {"src":"./static/icon/deepback.png","cmd":"back","arg":"N4-1","vis":"fabric_dme_P3_N3","l":1842,"t":1002,"w":48,"h":48},
        {"src":"./static/icon/deepclose.png","cmd":"sock","arg":"exit","vis":"-1","l":6070,"t":30,"w":80,"h":80}

    ],

    "bgm":{
        "path":"","volume":0.5
    }
}
export default {
    data(){
        return{
            //2,3,4,5,13,10,11,12,n11,n12,7,v14,v15,v16,v17,8,n19,n20,n21,17,n23,15,n25,n26,n27,n28
            debug: configdata.debug,
            hotAlpha: configdata.hotAlpha,
            path: configdata.path,
            bgm: configdata.bgm,
            res: configdata.res,
            datas: configdata.datas,
            ui: configdata.ui,
            hots: configdata.hots,
            uipp: configdata.uipp,
            isOfficial: configdata.isofficial,

            popnam: '',
            ctime: '00:00',
            ttime: '01:00',

            txt1: '卓悦故事',
            txt2: '卓悦服务\n有什么',
            txt3: '为什么\n您需要\n卓悦服务',
            txt4: '+100客户\n采用卓悦\n服务',
            isFull: false,
            subcur: -1,
            showPop: false,
            hy: 0, //159,420,650,890
        }
    },
    mixins: [basefunc],
    computed:{
        vidsrc(){
            return this.path+this.lang+this.datas[this.cur].name+'.'+this.datas[this.cur].type
        },
        svidsrc(){//官网版需把视频放到obs,并删掉public多余的视频
            if(!this.isOfficial)
                return this.path+this.lang+'s'+this.datas[this.cur].name+'.'+this.datas[this.cur].type
            else
                return 'https://panstone-share.obs.cn-south-1.myhuaweicloud.com/xw/JZone/ph2/'+'s'+this.datas[this.cur].name+'.'+this.datas[this.cur].type

        },
        curname(){
            return this.datas[this.cur].name
        },

        ...mapState('app',['cur','lang'])
    },
    
    components:{
        Vid,
        HotPP,
        Pop,
        Breath,
        ProgressBar,
        Info,
        Hot,
    },

    mounted(){
        // load config
        /*axios.get(config).then(response=>{
            const result = response.data
            //this.something = data
            this.assets = result.assets
        })*/
        // set up resize service and keyservice
        FontService.getInstance()
        //KeyService.getInstance().add('c', this.showControl)
        KeyService.getInstance().updateF(this.$el)
        ResizeService.getInstance().updateDirection(`r${this.res.x}x${this.res.y}`)
        this.initDatas()

        // KeyService.getInstance().add('space',this.simpp)
        // KeyService.getInstance().add('esc',this.handleUI.bind(this,'sock','exit'))
        // this.$refs.sound.volume=Number(this.bgm.volume)

        this.setNam('P0')

    },
    methods:{
        //showControl(){
            //console.log('add your control here like following')
            //window.open('/#/D1_3_Control','_blank')
        //},
        initDatas(){
            let s=''
            this.datas.map(item=>s+=item.name+'_')
            console.log(s)
            //三朵云需取消这里
            if(!configdata.isc3){
                this.setLang(configdata.startLan) 
            }
        },
        
        onPlayEnd(){
            if(this.datas[this.cur].next!=="")this.setNam(this.datas[this.cur].next)
        },
        setNam(nam){
            let c=-1
            this.datas.map((item,id)=>{
                if(item.name===nam) c=id
            })
            if(c!==-1){
                this.dealCur(c)
            }
        },
        dealCur(n){
            if(n>=0&&n<this.datas.length)this.setCur(n)
        },
        handleUI(cmd,arg){
            console.log(cmd,arg)
            if(cmd==='home')this.dealCur(0)
            else if(cmd==='prev') this.dealCur(this.cur-1)
            else if(cmd==='next') this.dealCur(this.cur+1)
            else if(cmd==='back'){//159,420,650,890
                if(this.curname==='s2')this.hy=1
                else if(['P2','P1'].indexOf(this.curname)!=-1)this.hy=2
                else if(['N4-1','dme','fabric','P3','N3'].indexOf(this.curname)!=-1)this.hy=3
                else this.hy=0
                this.setNam(arg)
            } 
            else if(cmd==='sock'&&arg==='exit') {window.opener=null;window.close()}
            else if(cmd==='sock')SocketService.getInstance().emit('j',{val:arg}) 
            
        },
        handleHot(cmd,arg){
            console.log(cmd,arg)
            if(cmd==='hot')this.setNam(arg)
            else if(cmd==='pop') {
                this.$refs.pop.showPop(true)
                this.popnam=arg
            }else if(cmd==='sock')SocketService.getInstance().emit('j',{val:arg})
            else if(cmd==='hot1'){
                this.subcur=0;
                this.setNam('s2');
                // if(this.curname==='P0'){
                //     this.showPop=true
                //     if(this.$refs.svid)this.$refs.svid.currentTime=0
                // }else{
                //     this.setNam('P0');
                //     this.subcur=0;
                // }
            }
            else if(cmd==='hot2'){this.subcur=1;this.setNam('P2')}
            else if(cmd==='hot3'){this.subcur=2;this.setNam('N4-1')}
            else if(cmd==='hot4'){this.subcur=3;this.setNam('N4-2')}
        },
        onback(){
            this.$refs.pop.showPop(false)
        },
        playSound(){
            this.$refs['sound'].play()
        },
        onpb(v){
            console.log('onpb:',v.val)
            this.$refs['vids'].seekfactor(v.val*0.01)
            this.$refs['pb'].setVal(v.val)
            this.$refs['pb'].setSeeking(false)
        },
        onProgress(v){
            // console.log(v)
            if(v)this.$refs['pb'].setVal(v*100)
            this.ctime=this.timeFormat(this.$refs['vids'].currentTime())
            this.ttime=this.timeFormat(this.$refs['vids'].duration())
        },
        openUrl(url){
            window.open(url,'_blank')
        },
        onover(v){
            // console.log('mouseover',v)
            // gsap.to(this.$refs['h'+v],.5,{alpha:1})
            gsap.to(this.$refs['r'+v],.5,{alpha:0})
        },
        onleave(v){
            // console.log('mouseleave')
            // gsap.to(this.$refs['h'+v],.5,{alpha:0})
            gsap.to(this.$refs['r'+v],.5,{alpha:1})
        },
        ...mapMutations('app',['setLang','setCur'])
    }

}
</script>

<style lang="sass" scoped>
@import '@/styles/common'
@import '@/styles/edge'
.content
    +full()
    display: flex
    justify-content: center
    align-items: center
    overflow: hidden
    .res
        background: #ddd
        .g1
            .bt0
                +size(170,170)
                &.b1
                    +pos(1653,102)
                &.b2
                    +pos(1653,340)
                &.b3
                    +pos(1653,575)
                &.b4
                    +pos(1653,812)
            .bt1
                +size(170,880)
                +pos(1652,102)
            .bt
                +size(281,266)
                // opacity: 0
                // transition: all .5s
                // &:hover
                //     opacity: .5
                &.bt2
                    +pos(1597,44)
                &.bt3
                    +pos(1597,282)
                &.bt4
                    +pos(1597,520)
                &.bt5
                    +pos(1597,755)
                .c1
                    +size(281,281)
                    

            .subbt1
                +size(200,50)
                +pos(1418,400)
            .subbt2
                +size(200,50)
                +pos(1418,600)
            .subbt3
                +size(200,55)
                +pos(1418,670)
            .subbt4
                +size(200,50)
                +pos(1418,870)

            .ihand
                +size(170/1.5,200/1.5)
                // +pos(1686+50,159)
                pointer-events: none
        .g3
            .ico
                // background-color: #f006
                +size(340,45)
                &.b1
                    +pos(95,748)
                &.b2
                    +pos(95,800)
                &.b3
                    +pos(475,748)
                &.b4
                    +pos(475,800)
.small
    +pos(138,190)
    +size(1383-138,890-190)
    overflow: hidden
    border-radius: pxToRem(20)
    transition: all .5s
.big
    +pos(0,0)
    +size(1920,1080)
    transition: all .5s

.popvid
    +full()
    object-fit: cover
.cover
    +size(1244,702)
    +pos(139,186)
@keyframes pulse3
  0%
    opacity: 1
    transform: none
  100%
    opacity: 0
    transform: scale(1.2)
.pulseForever1
    animation: pulse3 1s 0s infinite linear
</style>